import { BoxConsumableStatus } from "@modules/boxConsumable/entities/boxConsumableType"
import { BoxPurchasesEntity } from "@modules/boxPurchases/entities/boxPurchasesEntity"
import { BoxSubscriptionStatus } from "@modules/boxSubscription/gateway/boxSubscriptionApiDto"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseQuery } from "@tanstack/react-query"

export const useBoxPurchases = (
  memberId: string,
  fetchArchived?: boolean,
  consumableStatusFilter?: BoxConsumableStatus[] | null,
  subscriptionStatusFilter?: BoxSubscriptionStatus[] | null,
) => {
  const { boxPurchasesApi } = useServicesContext()

  const { data } = useSuspenseQuery({
    queryKey: [
      "boxPurchases",
      memberId,
      {
        fetchArchived,
        consumableStatusFilter,
        subscriptionStatusFilter,
      },
    ],
    queryFn: async () => {
      return await boxPurchasesApi.getFilteredPurchases(
        memberId,
        fetchArchived,
        consumableStatusFilter,
        subscriptionStatusFilter,
      )
    },
  })

  return {
    data: BoxPurchasesEntity.fromDto(data),
  }
}
